<template>
  <a
    v-if="isInternalLink(path)"
    :href="path"
    :target="[brankFlag ? '_blank' : '_self']"
  >
    <div class="contents-title-btn">
      <div class="page-number">
        <h1 class="number-txt" v-html="number"></h1>
      </div>
      <img :class="{showSubImg: isShowSubImg, 'sub-img': true}" :src="subImgSrc" alt="" />
      <div class="contents-title-txt" v-html="title"></div>
      <img v-if="iconImg" :src="iconImg" :class="icon" alt="" />
    </div>
  </a>

  <a v-else @click="transitionPage(path)">
    <div class="contents-title-btn">
      <div class="page-number">
        <h1 class="number-txt" v-html="number"></h1>
      </div>
      <img :class="{showSubImg: isShowSubImg, 'sub-img': true}" :src="subImgSrc" alt="" />
      <div class="contents-title-txt" v-html="title"></div>
      <img v-if="iconImg" :src="iconImg" :class="icon" alt="" />
    </div>
  </a>
</template>

<script>
import { computed } from "vue";
import { isInternalLink } from "@/assets/scripts/utils/url";
import pageTransition from "@/composables/pageTransition";
import { useStore } from "vuex";

export default {
  name: "ContentsTitleButton",
  props: {
    number: String,
    subImg: String,
    title: String,
    icon: String,
    path: { type: String, default: "" },
    brankFlag: { type: Boolean, default: false },
  },
  setup(props) {
    const { transitionPage } = pageTransition();
    const store = useStore();

    const clickLink = () => {
      let target = "_self"
      if(props.brankFlag){
        target = "tab_" + Math.random().toString(32).substring(2, 9);
      }
      window.open(props.path, target);
    }

    let iconImg = computed(() => {
      if (store.state.isDarkMode == false) {
        //テキスト内イメージモード変更
        for (let i = 0; i < store.state.textImg.length; i++) {
          let changeObjs = document.getElementsByClassName(store.state.textImg[i])
          for(let j = 0;j < changeObjs.length; j++){
            // console.log(1111);
            changeObjs[j].className = store.state.textImg[i];
          }
        }
        //アイコン分岐
        if (props.icon === "icon-blank") {
          return null;
        } else if (props.icon === "icon-movie") {
          //動画
          return store.state.iconImg.lightMovieImg;
        } else if (props.icon === "icon-sound") {
          //音声
          return store.state.iconImg.lightSoundImg;
        } else if (props.icon === "icon-simulation") {
          //シミュレーション
          return store.state.iconImg.lightSimulationImg;
        } else if (props.icon === "icon-work") {
          //ワークシート
          return store.state.iconImg.lightWorkImg;
        } else if (props.icon === "icon-document") {
          //資料
          return store.state.iconImg.lightDocumentImg;
        } else if (props.icon === "icon-practice") {
          //練習
          return store.state.iconImg.lightPracticeImg;
        } else if (props.icon === "icon-program") {
          //プログラミング
          return store.state.iconImg.lightProgramImg;
        } else if (props.icon === "icon-web") {
          //WEBページ
          return store.state.iconImg.lightWebImg;
        } else if (props.icon === "icon-link") {
          //他教科リンク
          return store.state.iconImg.lightLinkImg;
        } else if (props.icon === "icon-tablet") {
          //iPadとタッチペン
          return store.state.iconImg.lightTabletImg;
        } else if (props.icon === "icon-star") {
          //星型
          return store.state.iconImg.lightStarImg;
        } else if (props.icon === "icon-thinking") {
          //思考ツール
          return store.state.iconImg.lightThinkingImg;
        } else if (props.icon === "icon-vr") {
          //VR
          return store.state.iconImg.lightVrImg;
        } else if (props.icon === "icon-clean") {
          //感染症対策
          return store.state.iconImg.lightCleanImg;
        } else if (props.icon === "icon-conjugation") {
          //情報活用
          return store.state.iconImg.lightConjugationImg;
        } else if (props.icon === "icon-sdgs") {
          //SDGs
          return store.state.iconImg.lightSdgsImg;
        } else if (props.icon === "icon-quiz") {
          //クイズ
          return store.state.iconImg.lightQuizImg;
        } else if (props.icon === "icon-map") {
          //マップ
          return store.state.iconImg.lightMapImg;
        } else {
          return null;
        }
      } else {
        //テキスト内イメージモード変更
        for (let i = 0; i < store.state.textImg.length; i++) {
          let changeObjs = document.getElementsByClassName(store.state.textImg[i])
          for(let j = 0;j < changeObjs.length; j++){
            // console.log(1111);
            changeObjs[j].className = store.state.textImg[i]+" dark-mode";
          }
        }
        //アイコン分岐
        if (props.icon === "icon-blank") {
          return null;
        } else if (props.icon === "icon-movie") {
          //動画
          return store.state.iconImg.darkMovieImg;
        } else if (props.icon === "icon-sound") {
          //音声
          return store.state.iconImg.darkSoundImg;
        } else if (props.icon === "icon-simulation") {
          //シミュレーション
          return store.state.iconImg.darkSimulationImg;
        } else if (props.icon === "icon-work") {
          //ワークシート
          return store.state.iconImg.darkWorkImg
        } else if (props.icon === "icon-document") {
          //資料
          return store.state.iconImg.darkDocumentImg
        } else if (props.icon === "icon-practice") {
          //練習
          return store.state.iconImg.darkPracticeImg
        } else if (props.icon === "icon-program") {
          //プログラミング
          return store.state.iconImg.darkProgramImg
        } else if (props.icon === "icon-web") {
          //WEBページ
          return store.state.iconImg.darkWebImg
        } else if (props.icon === "icon-link") {
          //他教科リンク
          return store.state.iconImg.darkLinkImg
        } else if (props.icon === "icon-tablet") {
          //iPadとタッチペン
          return store.state.iconImg.darkTabletImg
        } else if (props.icon === "icon-star") {
          //星型
          return store.state.iconImg.darkStarImg
        } else if (props.icon === "icon-thinking") {
          //思考ツール
          return store.state.iconImg.darkThinkingImg
        } else if (props.icon === "icon-vr") {
          //VR
          return store.state.iconImg.darkVrImg;
        } else if (props.icon === "icon-clean") {
          //感染症対策
          return store.state.iconImg.darkCleanImg;
        } else if (props.icon === "icon-conjugation") {
          //情報活用
          return store.state.iconImg.darkConjugationImg;
        } else if (props.icon === "icon-sdgs") {
          //SDGs
          return store.state.iconImg.darkSdgsImg;
        } else if (props.icon === "icon-quiz") {
          //クイズ
          return store.state.iconImg.darkQuizImg;
        } else if (props.icon === "icon-map") {
          //マップ
          return store.state.iconImg.darkMapImg;
        } else {
          return null;
        }
      }
    });

    let subImgSrc = computed(() => {
      if(props.subImg === ""){
        return null;
      }else if(props.subImg === "sub01"){
        return require("../assets/images/button_sub_imgs/contents_title_sub01.png");
      }else if(props.subImg === "sub02"){
        return require("../assets/images/button_sub_imgs/contents_title_sub02.png");
      }else if(props.subImg === "sub03"){
        return require("../assets/images/button_sub_imgs/contents_title_sub03.png");
      }else if(props.subImg === "sub04"){
        return require("../assets/images/button_sub_imgs/contents_title_sub04.png");
      }else if(props.subImg === "sub05"){
        return require("../assets/images/button_sub_imgs/contents_title_sub05.png");
      }else if(props.subImg === "sub06"){
        return require("../assets/images/button_sub_imgs/contents_title_sub06.png");
      }else if(props.subImg === "sub07"){
        return require("../assets/images/button_sub_imgs/contents_title_sub07.png");
      }else if(props.subImg === "sub08"){
        return require("../assets/images/button_sub_imgs/contents_title_sub08.png");
      }else if(props.subImg === "sub09"){
        return require("../assets/images/button_sub_imgs/contents_title_sub09.png");
      }else if(props.subImg === "sub10"){
        return require("../assets/images/button_sub_imgs/contents_title_sub10.png");
      }else if(props.subImg === "sub11"){
        return require("../assets/images/button_sub_imgs/contents_title_sub11.png");
      }else if(props.subImg === "sub12"){
        return require("../assets/images/button_sub_imgs/contents_title_sub12.png");
      }else if(props.subImg === "sub13"){
        return require("../assets/images/button_sub_imgs/contents_title_sub13.png");
      }else if(props.subImg === "sub14"){
        return require("../assets/images/button_sub_imgs/contents_title_sub14.png");
      }else if(props.subImg === "sub15"){
        return require("../assets/images/button_sub_imgs/contents_title_sub15.png");
      }else if(props.subImg === "sub16"){
        return require("../assets/images/button_sub_imgs/contents_title_sub16.png");
      }else if(props.subImg === "sub17"){
        return require("../assets/images/button_sub_imgs/contents_title_sub17.png");
      }else if(props.subImg === "sub18"){
        return require("../assets/images/button_sub_imgs/contents_title_sub18.png");
      }else if(props.subImg === "sub19"){
        return require("../assets/images/button_sub_imgs/contents_title_sub19.png");
      }else if(props.subImg === "sub20"){
        return require("../assets/images/button_sub_imgs/contents_title_sub20.png");
      }else if(props.subImg === "sub21"){
        return require("../assets/images/button_sub_imgs/contents_title_sub21.png");
      }else if(props.subImg === "sub22"){
        return require("../assets/images/button_sub_imgs/contents_title_sub22.png");
      }else if(props.subImg === "sub23"){
        return require("../assets/images/button_sub_imgs/contents_title_sub23.png");
      }else if(props.subImg === "sub24"){
        return require("../assets/images/button_sub_imgs/contents_title_sub24.png");
      }else if(props.subImg === "sub25"){
        return require("../assets/images/button_sub_imgs/contents_title_sub25.png");
      }else if(props.subImg === "sub26"){
        return require("../assets/images/button_sub_imgs/contents_title_sub26.png");
      }else if(props.subImg === "sub27"){
        return require("../assets/images/button_sub_imgs/contents_title_sub27.png");
      }else if(props.subImg === "sub28"){
        return require("../assets/images/button_sub_imgs/contents_title_sub28.png");
      }else if(props.subImg === "sub29"){
        return require("../assets/images/button_sub_imgs/contents_title_sub29.png");
      }else if(props.subImg === "sub30"){
        return require("../assets/images/button_sub_imgs/contents_title_sub30.png");
      }else if(props.subImg === "sub31"){
        return require("../assets/images/button_sub_imgs/contents_title_sub31.png");
      }else if(props.subImg === "sub32"){
        return require("../assets/images/button_sub_imgs/contents_title_sub32.png");
      }else if(props.subImg === "sub33"){
        return require("../assets/images/button_sub_imgs/contents_title_sub33.png");
      }else if(props.subImg === "sub34"){
        return require("../assets/images/button_sub_imgs/contents_title_sub34.png");
      }else if(props.subImg === "sub35"){
        return require("../assets/images/button_sub_imgs/contents_title_sub35.png");
      }else if(props.subImg === "sub36"){
        return require("../assets/images/button_sub_imgs/contents_title_sub36.png");
      }else if(props.subImg === "sub37"){
        return require("../assets/images/button_sub_imgs/contents_title_sub37.png");
      }else if(props.subImg === "sub38"){
        return require("../assets/images/button_sub_imgs/contents_title_sub38.png");
      }else if(props.subImg === "sub39"){
        return require("../assets/images/button_sub_imgs/contents_title_sub39.png");
      }else if(props.subImg === "sub40"){
        return require("../assets/images/button_sub_imgs/contents_title_sub40.png");
      }else if(props.subImg === "sub41"){
        return require("../assets/images/button_sub_imgs/contents_title_sub41.png");
      }else if(props.subImg === "sub42"){
        return require("../assets/images/button_sub_imgs/contents_title_sub42.png");
      }else if(props.subImg === "sub43"){
        return require("../assets/images/button_sub_imgs/contents_title_sub43.png");
      }else if(props.subImg === "sub44"){
        return require("../assets/images/button_sub_imgs/contents_title_sub44.png");
      }else if(props.subImg === "sub45"){
        return require("../assets/images/button_sub_imgs/contents_title_sub45.png");
      }else if(props.subImg === "sub46"){
        return require("../assets/images/button_sub_imgs/contents_title_sub46.png");
      }else if(props.subImg === "sub47"){
        return require("../assets/images/button_sub_imgs/contents_title_sub47.png");
      }else if(props.subImg === "sub48"){
        return require("../assets/images/button_sub_imgs/contents_title_sub48.png");
      }else if(props.subImg === "sub49"){
        return require("../assets/images/button_sub_imgs/contents_title_sub49.png");
      }else if(props.subImg === "sub50"){
        return require("../assets/images/button_sub_imgs/contents_title_sub50.png");
      }else if(props.subImg === "sub51"){
        return require("../assets/images/button_sub_imgs/contents_title_sub51.png");
      }else if(props.subImg === "sub52"){
        return require("../assets/images/button_sub_imgs/contents_title_sub52.png");
      }else if(props.subImg === "sub53"){
        return require("../assets/images/button_sub_imgs/contents_title_sub53.png");
      }else if(props.subImg === "sub54"){
        return require("../assets/images/button_sub_imgs/contents_title_sub54.png");
      }else if(props.subImg === "sub55"){
        return require("../assets/images/button_sub_imgs/contents_title_sub55.png");
      }else if(props.subImg === "sub56"){
        return require("../assets/images/button_sub_imgs/contents_title_sub56.png");
      }else if(props.subImg === "sub57"){
        return require("../assets/images/button_sub_imgs/contents_title_sub57.png");
      }else if(props.subImg === "sub58"){
        return require("../assets/images/button_sub_imgs/contents_title_sub58.png");
      }else if(props.subImg === "sub59"){
        return require("../assets/images/button_sub_imgs/contents_title_sub59.png");
      }else if(props.subImg === "sub60"){
        return require("../assets/images/button_sub_imgs/contents_title_sub60.png");
      }else if(props.subImg === "sub61"){
        return require("../assets/images/button_sub_imgs/contents_title_sub61.png");
      }else if(props.subImg === "sub62"){
        return require("../assets/images/button_sub_imgs/contents_title_sub62.png");
      }else if(props.subImg === "sub63"){
        return require("../assets/images/button_sub_imgs/contents_title_sub63.png");
      }else if(props.subImg === "sub64"){
        return require("../assets/images/button_sub_imgs/contents_title_sub64.png");
      }else if(props.subImg === "sub65"){
        return require("../assets/images/button_sub_imgs/contents_title_sub65.png");
      }else if(props.subImg === "sub66"){
        return require("../assets/images/button_sub_imgs/contents_title_sub66.png");
      }else if(props.subImg === "sub67"){
        return require("../assets/images/button_sub_imgs/contents_title_sub67.png");
      }else if(props.subImg === "sub68"){
        return require("../assets/images/button_sub_imgs/contents_title_sub68.png");
      }else if(props.subImg === "sub69"){
        return require("../assets/images/button_sub_imgs/contents_title_sub69.png");
      }else if(props.subImg === "sub70"){
        return require("../assets/images/button_sub_imgs/contents_title_sub70.png");
      }else if(props.subImg === "sub71"){
        return require("../assets/images/button_sub_imgs/contents_title_sub71.png");
      }else if(props.subImg === "sub72"){
        return require("../assets/images/button_sub_imgs/contents_title_sub72.png");
      }else if(props.subImg === "sub73"){
        return require("../assets/images/button_sub_imgs/contents_title_sub73.png");
      }else if(props.subImg === "sub74"){
        return require("../assets/images/button_sub_imgs/contents_title_sub74.png");
      }else if(props.subImg === "sub75"){
        return require("../assets/images/button_sub_imgs/contents_title_sub75.png");
      }else if(props.subImg === "sub76"){
        return require("../assets/images/button_sub_imgs/contents_title_sub76.png");
      }else if(props.subImg === "sub77"){
        return require("../assets/images/button_sub_imgs/contents_title_sub77.png");
      }else if(props.subImg === "sub78"){
        return require("../assets/images/button_sub_imgs/contents_title_sub78.png");
      }else if(props.subImg === "sub79"){
        return require("../assets/images/button_sub_imgs/contents_title_sub79.png");
      }else if(props.subImg === "sub80"){
        return require("../assets/images/button_sub_imgs/contents_title_sub80.png");
      }else if(props.subImg === "sub81"){
        return require("../assets/images/button_sub_imgs/contents_title_sub81.png");
      }else if(props.subImg === "sub82"){
        return require("../assets/images/button_sub_imgs/contents_title_sub82.png");
      }else if(props.subImg === "sub83"){
        return require("../assets/images/button_sub_imgs/contents_title_sub83.png");
      }else if(props.subImg === "sub84"){
        return require("../assets/images/button_sub_imgs/contents_title_sub84.png");
      }else if(props.subImg === "sub85"){
        return require("../assets/images/button_sub_imgs/contents_title_sub85.png");
      }else if(props.subImg === "sub86"){
        return require("../assets/images/button_sub_imgs/contents_title_sub86.png");
      }else if(props.subImg === "sub87"){
        return require("../assets/images/button_sub_imgs/contents_title_sub87.png");
      }else if(props.subImg === "sub88"){
        return require("../assets/images/button_sub_imgs/contents_title_sub88.png");
      }else if(props.subImg === "sub89"){
        return require("../assets/images/button_sub_imgs/contents_title_sub89.png");
      }else if(props.subImg === "sub90"){
        return require("../assets/images/button_sub_imgs/contents_title_sub90.png");
      }else if(props.subImg === "sub91"){
        return require("../assets/images/button_sub_imgs/contents_title_sub91.png");
      }else if(props.subImg === "sub92"){
        return require("../assets/images/button_sub_imgs/contents_title_sub92.png");
      }else if(props.subImg === "sub93"){
        return require("../assets/images/button_sub_imgs/contents_title_sub93.png");
      }else if(props.subImg === "sub94"){
        return require("../assets/images/button_sub_imgs/contents_title_sub94.png");
      }else if(props.subImg === "sub95"){
        return require("../assets/images/button_sub_imgs/contents_title_sub95.png");
      }else if(props.subImg === "sub96"){
        return require("../assets/images/button_sub_imgs/contents_title_sub96.png");
      }else if(props.subImg === "sub97"){
        return require("../assets/images/button_sub_imgs/contents_title_sub97.png");
      }else if(props.subImg === "sub98"){
        return require("../assets/images/button_sub_imgs/contents_title_sub98.png");
      }else if(props.subImg === "sub99"){
        return require("../assets/images/button_sub_imgs/contents_title_sub99.png");
      }else if(props.subImg === "sub100"){
        return require("../assets/images/button_sub_imgs/contents_title_sub100.png");
      }else{
        return null;
      }
    });

    let isShowSubImg = computed(() => {
      return typeof props.subImg === "undefined";
    });
    
    return {
      iconImg,
      subImgSrc,
      transitionPage,
      isInternalLink,
      isShowSubImg,
      clickLink,
    };
  },
};
</script>

<style scoped lang="stylus">
@import '../assets/styles/config.styl';

a
  text-decoration: none
  display: block
  cursor: pointer

.contents-title-btn
  transform translateZ(0)
  position: relative
  width: 57vw
  height: auto
  color: black
  background-color: white
  display: flex
  border-radius: 21px
  font-size: 12px
  filter: drop-shadow(0px 3px 10px rgba(0, 149, 220, 0.5))
  text-align: left
  align-items: center
  transition all .5s ease-out

.dark-mode
  .contents-title-btn
    color var(--dark-white)
    background-color var(--dark-deepblue)
    transition all .5s ease-out
    filter: drop-shadow(0px 3px 10px rgba(0, 149, 220, 0))

// .shadow
//   filter: drop-shadow(0px 3px 10px rgba(0, 149, 220, 0))

.page-number
  transform translateZ(0)
  position: absolute
  width: 120px
  height: 100%
  color: white
  background-color: var(--light-blue)
  display: flex
  align-items: center
  justify-content: center
  border-bottom-left-radius: 10px
  border-top-left-radius: 10px

.dark-mode
  .page-number
    background-color var(--dark-deepblue-light)
    transition all .5s ease-out

.number-txt
  line-height: 20px
  font-size: 18px
  width: 110px
  text-align: center

.contents-title-txt
  width: 90%
  padding-left: 15px
  padding-top: 3%
  padding-bottom: 2.75%
  margin-bottom: 4.5px
  font-size 20px
  font-weight bold

.icon-movie
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-sound
  width: 39.81px
  margin-right: 20px
  margin-left: 2vw

.icon-simulation
  width: 25.01px
  margin-right: 28px
  margin-left: 2vw

.icon-work
  width: 40.74px
  margin-right: 18px
  margin-left: 2vw

.icon-document
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-practice
  width: 40.76px
  margin-right: 18px
  margin-left: 2vw

.icon-program
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-web
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-link
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-tablet
  width: 40.74px
  margin-right: 18px
  margin-left: 2vw

.icon-star
  width: 30.82px
  margin-right: 24px
  margin-left: 2vw

.icon-thinking
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-vr
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-clean
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-conjugation
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-sdgs
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-quiz
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-map
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.sub-img
  border: 0
  padding-left:140px
  height 35px

.showSubImg
  visibility hidden
  width 0
  height 0

</style>
